import axios from 'axios'
import {MessageBox, Notification} from 'element-ui'
import store from '@/store'
import {getToken} from '@/utils/localStorage'
import router from '@/router'
import JSONBig from 'json-bigint'

const setting = require('../../src/settings.js')
const qs = require('qs')
const request = axios.create({
    baseURL: process.env['VUE_APP_BASE_API'],
    headers: { 'Content-Type': setting.defaultContentType }
})

const res = axios.create({
    // 接口的基础连接
    baseURL: 'https://cloud.stores.mankuaiaa.cn',
    // 自定义返回的元素数据,axios会默认用JSON.parse
    // `transformResponse` 在传递给 then/catch 前，允许修改响应数据
    transformResponse: [
        function (data) {
            // 对 data 进行任意转换处理
            try {
                // 如果转换成功则返回转换的数据结果
                const json = JSONBig({
                    storeAsString: true
                })
                return json.parse(data)
            } catch (err) {
                return data
            }
        }
    ]
})

request.interceptors.request.use(async config => {
    if (getToken()) {
        // config.headers['x-access-token'] = getToken().split("_")[0] + "_ms"
        config.headers['x-access-token'] = getToken()
    }
    if (config.headers['Content-Type'] === 'application/x-www-form-urlencoded') {
        config.data = qs.stringify(config.data)
    }
    return config
}, error => {
    Notification.error(error)
    return Promise.reject(error)
})

// 添加响应拦截器
request.interceptors.response.use(function (response) {
    const { status, data } = response
    if (status >= 200 && status < 300) {
        if (data.success) {
            return response.data
        } else if (data.code === 401) {
            router.push({path: '/login'})
            return Promise.reject(response)
        } else {
            Notification.error(data.msg)
            return Promise.reject(response)
        }
    }
    // 对响应数据做点什么
    return response;
}, function (error) {
    switch (error.response.status) {
        case 500:
            Notification.error("系统繁忙")
            break;
        case 403:
            MessageBox.alert(
                '登录状态已过期，或已在其他地方登陆！',
                '系统提示',
                {
                    type: 'warning'
                }
            ).then(() => {
                store.dispatch('user/logout').then(() => {
                    router.push({ path: '/login' })
                })
            })
            // Notification.error("非法访问")
            break;
        case 504:
            Notification.error("连接超时")
            break;
        default:
            Notification.error(error.response.status + "")
            break;
    }
    // 对响应错误做点什么
    return Promise.reject(error);
});


export default request
